import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/_helpers/validation-utils';
import { CurrencyModel } from 'src/app/_models/currency.model';
import { IDiscountable } from 'src/app/_models/discountable-model';

@Component({
    selector: 'discount-input',
    templateUrl: './discount-input.component.html',
    styleUrls: ['./discount-input.component.scss']
})
export class DiscountInputComponent implements OnInit {

    @Input() title: string;
    @Input() currency: CurrencyModel;
    @Input('data') inputData: IDiscountable;
    discountForm: UntypedFormGroup;

    private _localData: IDiscountable;

    constructor(
        private formBuilder: UntypedFormBuilder,
    ) { }

    ngOnInit(): void {
        this.createForm();
    }

    reset() {
        this._localData = null;
        this.createForm();
    }

    createForm() {
        this.discountForm = this.formBuilder.group({
            discount: [this.discountData.discount, this.discountData.isPercentageDiscount ?
                CustomValidators.getDiscountRateValidator()
                : Validators.compose([CustomValidators.getPositiveNumberValidator(), Validators.max(this.discountData.discountableTotal)])
            ],
            isPercentageDiscount: [!!this.discountData.isPercentageDiscount],
        });
    }

    get discountData() {
        if (!this._localData) {
            this._localData = (({ isPercentageDiscount, discount }) =>
              ({ isPercentageDiscount, discount } as IDiscountable))(this.inputData);
        }
        this._localData.discountableTotal = this.inputData.discountableTotal;
        return this._localData;
    }

    onPercentageDiscountClick(value: boolean) {
        this.discountData.isPercentageDiscount = value;
        this.discountData.discount = this.discountForm.controls.discount.value;
        this.createForm();
        this.discountForm.controls.discount.markAsTouched();
    }

    onSubmit() {
        this.inputData.isPercentageDiscount = this.discountData.isPercentageDiscount;
        this.inputData.discount = this.discountForm.controls.discount.value;
        this.reset();
    }

    onCancel() {
        this.reset();
    }
}
